/**
 * @file: preshing-currency-abbreviation.pipe.ts
 * @since: 17-Oct-2017
 * @desc: PershingPhoneFormatPipe pipe is used to formate simple phone number into
 *        (AreaCode) (PhoneNumber) format.
 */
import { Pipe, PipeTransform } from '@angular/core';

/**
 * @whatItDoes Abbriviate the currently in K, M G, T, P and E format
 * @howToUse: {{ output | pershingCurrencyAbbreviation:decimalPlaces }}
 * @desc
 *  in above the decimalPlaces defined as the fixed values after decimal in abbreviation
 *  input as 20000 with decimalPlaces as 0 results in 20K
 *  input as 34230000 with decimalPlaces as 3 results in 34.230M
 */

@Pipe({
    name: 'pershingCurrencyAbbreviation'
})
export class PershingCurrencyAbbreviationPipe implements PipeTransform {
    transform(value: any, decimalPlaces: any): string {

        const SI_POSTFIXES = ['', 'K', 'M', 'B', 'T', 'P', 'E'];
        const tier = Math.log10(Math.abs(value)) / 3 | 0;
        // if zero, we don't need a prefix
        if (tier === 0) {
            return value;
        }

        // get postfix and determine scale
        const postfix = SI_POSTFIXES[tier];
        const scale = Math.pow(10, tier * 3);

        // scale the number
        const scaled = value / scale;

        // format number and add postfix as suffix
        let formatted = scaled.toFixed(decimalPlaces) + '';

        // remove '.0*' case
        if (/\.0*$/.test(formatted)) {
            formatted = formatted.substr(0, formatted.length - decimalPlaces - 1);
        }

        return formatted + postfix;
    }
}
